import { Environment } from 'env/Environment'

export const env: Environment = {
  apiUrl: `https://api${window.location.hostname.substr(
    window.location.hostname.indexOf('-') === -1
      ? window.location.hostname.indexOf('.')
      : window.location.hostname.indexOf('-'),
  )}`,
  loginUrl: `https://api${window.location.hostname.substr(
    window.location.hostname.indexOf('-') === -1
      ? window.location.hostname.indexOf('.')
      : window.location.hostname.indexOf('-'),
  )}/api/login`,
  logoutUrl: `https://api${window.location.hostname.substr(
    window.location.hostname.indexOf('-') === -1
      ? window.location.hostname.indexOf('.')
      : window.location.hostname.indexOf('-'),
  )}/api/logout`,
  debug: false,
  debugConnectFrame: false,
  production: true,
  stripeApiKey:
    'pk_live_51Pj0X7GDKk9y36m2yBgP51T9EKtqSuUVqo74DCHv8ghD6pLZWp8sS36JmF99YRc1cKv72dw5oJ6x6lyFxLdMkXV500tMIdFr2d',
  library: 'production',
}
